/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />


module Meevo.Components.Controls {
    "use strict";

    export class MeevoPromotionalBlock implements angular.IDirective {
        restrict = "AE";
        scope = {
            content: '='
        };
        template = `
            <div class="promotional-block" ng-repeat="item in content">
                <div class="promo-item-wrapper" >
                    <img class="promo-image" ng-src="{{item.advertisementImageUrl}}" />
                    <div class="promo-content" ng-style="{'color': item.accentColor}">
                        <div class="promo-item-header">{{item.displayName}}</div>
                        <h4>{{item.description}}</h4>
                    </div>
                </div>
            </div>
        `;

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoPromotionalBlock();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPromotionalBlock", MeevoPromotionalBlock.factory());
}